import React, { Component } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';
import renderHTML from 'react-render-html';
import EventsAppWrapper from '../../events-app-wrapper';
import ViewHeader from '../../components/view-header';
import Loader from '../../components/loader';
import SummaryDetails from '../ssm-homepage/ssm-components/summary-details/summary-details';
import {
  stripStartingAndEndingPTags,
  validateNumber,
} from '../ssm-homepage/ssm-homepage.actions';
import Button from '../../components/button/button';
import CurrentServices from './components/current-services/current-services';
import {
  CUSTOMER_DETAILS_COMPANY_TRADING_NAME,
  CUSTOMER_DETAILS_ABN_ACN,
  CUSTOMER_DETAILS_STREET_ADDRESS,
  CUSTOMER_DETAILS_SUBURB,
  CUSTOMER_DETAILS_STATE,
  CUSTOMER_DETAILS_POST_CODE,
  CUSTOMER_DETAILS_FIRST_NAME,
  CUSTOMER_DETAILS_LAST_NAME,
  CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER,
  CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS,
  CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER,
  RADIO_BUTTON_CONFIRM_ID,
  RADIO_BUTTON_REVIEW_ID,
  RADIO_BUTTON_CANCEL_ALL_ID,
  RADIO_BUTTON_CANCEL_ON_DEADLINE_ID,
  DEBUG_MODE,
} from '../../app-constants';
import SelectionOption from '../ssm-homepage/ssm-components/selection-option/selection-option';
import AdditionalInformation from './components/additional-information/additional-information';
import CustomerDetails from './components/customer-details/customer-details';
import AdditionalLicences from './components/additional-licences/additional-licences';
import HMEExpandCollapse from './components/hme-expand-collapse/hme-expand-collapse';
import './hosted-migration.css';
import {
  prepareHMESubmitData,
  scrollElementIntoViewCenter,
  validateCustomerDetailsFormFields,
  validateCustomerFieldsOnSubmit,
  populateCurrentServiceRadioStatusOnSelectAll,
} from './hosted-migration.actions';
import FormError from '../../components/form/error/error';

class HostedMigrationView extends Component {
  constructor() {
    super();
    this.onCurrentServicesExpandCollapseClick = this.onCurrentServicesExpandCollapseClick.bind(this);
    this.onCurrentServicesRadioButtonCallBackAction = this.onCurrentServicesRadioButtonCallBackAction.bind(this);
    this.state = {
      customerDetailsFields: {
        [CUSTOMER_DETAILS_COMPANY_TRADING_NAME]: '',
        [CUSTOMER_DETAILS_ABN_ACN]: '',
        [CUSTOMER_DETAILS_STREET_ADDRESS]: '',
        [CUSTOMER_DETAILS_SUBURB]: '',
        [CUSTOMER_DETAILS_STATE]: '',
        [CUSTOMER_DETAILS_POST_CODE]: '',
        [CUSTOMER_DETAILS_FIRST_NAME]: '',
        [CUSTOMER_DETAILS_LAST_NAME]: '',
        [CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER]: '',
        [CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS]: '',
        [CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER]: '',
      },
      customerDetailsFieldsErrors: {
        [CUSTOMER_DETAILS_COMPANY_TRADING_NAME]: false,
        [CUSTOMER_DETAILS_ABN_ACN]: false,
        [CUSTOMER_DETAILS_STREET_ADDRESS]: false,
        [CUSTOMER_DETAILS_SUBURB]: false,
        [CUSTOMER_DETAILS_STATE]: false,
        [CUSTOMER_DETAILS_POST_CODE]: false,
        [CUSTOMER_DETAILS_FIRST_NAME]: false,
        [CUSTOMER_DETAILS_LAST_NAME]: false,
        [CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER]: false,
        [CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS]: false,
        [CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER]: false,
      },
      confirmChangesRadioButtons: [ // this is redundant can make a single object and set in state on application load
        { id: RADIO_BUTTON_CONFIRM_ID, checked: false },
        { id: RADIO_BUTTON_REVIEW_ID, checked: false },
      ],
      additionalLicencesQuantity: { // need to set state in componentDidMount dynamically on Application Load
        webBasedExchangeOnline: 0,
        exchangeOnlineWithOutlookSupport: 0,
        office365BusinessEssentials: 0,
        office365BusinessPremium: 0,
      },
      currentServicesRadioButtonStatus: [],
      currentServicesSelectAllRadioButtonStatus: [],
      cancelServicesRadioButtons: [
        { id: RADIO_BUTTON_CANCEL_ALL_ID, checked: false },
        { id: RADIO_BUTTON_CANCEL_ON_DEADLINE_ID, checked: false },
      ],
      additionalInfoComments: '',
      isAdditionalLicencesOpen: false,
      isSubmitButtonEnabled: false,
      showCurrentSerivceError: false,
      allServicesCancelled: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded) {
      console.log('hosted migration page loaded'); // eslint-disable-line
    }
  }

  onConfirmChangesRadioButtonsToggle = (radioButtonClicked) => {
    const updatedConfirmChangesRadioButtons = this.prepareConfirmChangesRadioButtonStateOnToggle(
      this.state.confirmChangesRadioButtons, radioButtonClicked);
    this.setState({ confirmChangesRadioButtons: updatedConfirmChangesRadioButtons, isSubmitButtonEnabled: radioButtonClicked.checked });
  };

  onCancelServicesRadioButtonsToggle = (radioButtonClicked) => {
    const updatedCancelServicesRadioButtons = this.prepareConfirmChangesRadioButtonStateOnToggle(
      this.state.cancelServicesRadioButtons, radioButtonClicked);
    this.setState({ cancelServicesRadioButtons: updatedCancelServicesRadioButtons, isSubmitButtonEnabled: radioButtonClicked.checked });
  };

  onCurrentServicesExpandCollapseClick() {
    this.setState({ isAdditionalLicencesOpen: !this.state.isAdditionalLicencesOpen });
  }

  onCurrentServicesRadioButtonCallBackAction(radioButtonClicked) {
    const newCurrentServicesRadioButtonStatus = this.prepareServicesChangesRadioButtonStateOnToggle(
      this.state.currentServicesRadioButtonStatus, radioButtonClicked);
    const allServicesCancelled = this.validateAllServicesCancelled(newCurrentServicesRadioButtonStatus);
    this.setState({
      currentServicesRadioButtonStatus: newCurrentServicesRadioButtonStatus,
      allServicesCancelled,
      currentServicesSelectAllRadioButtonStatus: [],
    });
  }

  onCurrentServicesSelectAllRadioButtonCallBackAction = (radioButtonClicked) => {
    const { customerEmailAddresses } = this.props;
    const newCurrentServicesSelectAllRadioButtonStatus = [{ id: radioButtonClicked.id, checked: true }];
    const allServicesCancelled = radioButtonClicked.id.split('-')[2] === 'cancel';
    const newCurrentServicesRadioButtonStatus = populateCurrentServiceRadioStatusOnSelectAll(customerEmailAddresses, radioButtonClicked);
    this.setState({
      currentServicesRadioButtonStatus: newCurrentServicesRadioButtonStatus,
      currentServicesSelectAllRadioButtonStatus: newCurrentServicesSelectAllRadioButtonStatus,
      allServicesCancelled,
    });
  }

  onResolved = () => {
    if (DEBUG_MODE) {
      console.log('RESOLVED1', this.recaptcha.getResponse()); // eslint-disable-line
    }
    const { customerEmailAddresses } = this.props;
    const { submitHMECustomerData } = this.props.actions;
    const dataForSubmit = prepareHMESubmitData(this.state, customerEmailAddresses, this.recaptcha.getResponse());
    submitHMECustomerData(dataForSubmit);
  };

  onError= () => {
    if (DEBUG_MODE) {
      console.log('Facing network error .Please check you internet connection'); // eslint-disable-line
    }
  };

  onExpired= () => {
    if (DEBUG_MODE) {
      console.log('token got expired'); // eslint-disable-line
    }
  };

  prepareConfirmChangesRadioButtonStateOnToggle = (radioButtonOptions, radioButtonClicked) => (radioButtonOptions
    .map((radioButton) => {
      if (radioButton.id === radioButtonClicked.id) {
        return { ...radioButton, checked: radioButtonClicked.checked };
      }
      return { ...radioButton, checked: !radioButtonClicked.checked };
    }));

    prepareServicesChangesRadioButtonStateOnToggle = (radioButtonOptions, radioButtonClicked) => {
      let newCurrentServicesRadioButtonStatus;
      if (radioButtonOptions.length === 0) {
        const { customerEmailAddresses } = this.props;
        newCurrentServicesRadioButtonStatus = customerEmailAddresses.map(emailAddress => (
          { emailAddress, id: '', checked: false }
        ));
        return newCurrentServicesRadioButtonStatus.map((radioButton) => {
          if (radioButtonClicked.id.includes(radioButton.emailAddress)) {
            return { ...radioButton, id: radioButtonClicked.id, checked: radioButtonClicked.checked };
          }
          return { ...radioButton };
        });
      }
      return radioButtonOptions.map((radioButton) => {
        if (radioButtonClicked.id.includes(radioButton.emailAddress)) {
          return { ...radioButton, id: radioButtonClicked.id, checked: radioButtonClicked.checked };
        }
        return { ...radioButton };
      });
    };
  handleOnChangeCustomerDetails = (event) => {
    const { customerDetailsFields } = this.state;
    if (customerDetailsFields[event.target.id] !== undefined) {
      this.setState({ customerDetailsFields: { ...customerDetailsFields, [event.target.id]: event.target.value } });
    }
  };

  handleOnBlurCustomerDetails = (event) => {
    const { customerDetailsFields } = this.state;
    this.customerDetailsFormFieldValidationOnBlur(event.target.id, event.target.value);
    if (customerDetailsFields[event.target.id] !== undefined) {
      this.setState({ customerDetailsFields: { ...customerDetailsFields, [event.target.id]: event.target.value } });
    }
  };

  handleOnChangeAdditionalInfo = (event) => {
    this.setState({ additionalInfoComments: event.target.value });
  };

  handleOnBlurAdditionalInfo = (event) => {
    this.setState({ additionalInfoComments: event.target.value });
  };

  handleOnChangeAdditionLicences = (event) => {
    const { additionalLicencesQuantity } = this.state;
    if (validateNumber(event.target.value)) {
      this.setState({ additionalLicencesQuantity: { ...additionalLicencesQuantity, [event.target.id]: event.target.value } });
    }
  };

  handleOnBlurAdditionLicences = (event) => {
    const { additionalLicencesQuantity } = this.state;
    if (event.target.value.length > 0 && validateNumber(event.target.value)) {
      this.setState({ additionalLicencesQuantity: { ...additionalLicencesQuantity, [event.target.id]: event.target.value } });
    } else {
      this.setState({ additionalLicencesQuantity: { ...additionalLicencesQuantity, [event.target.id]: 0 } });
    }
  };

  customerDetailsFormFieldValidationOnBlur = (id, value) => {
    const { customerDetailsFieldsErrors } = this.state;
    const validatedCustomerDetailsFieldValue = validateCustomerDetailsFormFields(id, value);
    this.setState({ customerDetailsFieldsErrors: { ...customerDetailsFieldsErrors, [id]: validatedCustomerDetailsFieldValue } });
  };

  handleSubmit = () => {
    const { customerDetailsFields, currentServicesRadioButtonStatus, allServicesCancelled } = this.state;
    const showCurrentSerivceError = currentServicesRadioButtonStatus.length === 0
      || currentServicesRadioButtonStatus.some(currentService => currentService.checked === false);
    if (allServicesCancelled) {
      if (showCurrentSerivceError) {
        this.currentServicesRadioButtonErrorStatus(showCurrentSerivceError);
      } else {
        this.recaptcha.execute();
      }
    } else {
      const newCustomerDetailsFieldsErrors = validateCustomerFieldsOnSubmit(customerDetailsFields);
      this.setState({ customerDetailsFieldsErrors: newCustomerDetailsFieldsErrors });
      const isCustomerDetailsFieldsHasError = Object.keys(newCustomerDetailsFieldsErrors)
        .every(customerDetailsField => !newCustomerDetailsFieldsErrors[customerDetailsField]);
      if (isCustomerDetailsFieldsHasError && !showCurrentSerivceError) {
        this.recaptcha.execute();
      } else if (showCurrentSerivceError) {
        this.currentServicesRadioButtonErrorStatus(showCurrentSerivceError);
      } else {
        scrollElementIntoViewCenter('customer-details');
      }
    }
  };

  currentServicesRadioButtonErrorStatus = (errorMessageStatus) => {
    if (errorMessageStatus) {
      scrollElementIntoViewCenter('hme-expand-normal');
    }
    this.setState({ showCurrentSerivceError: errorMessageStatus });
  };

  validateAllServicesCancelled = (currentServicesRadioButtonStatus) => {
    const checkCancelledServices = currentServicesRadioButtonStatus.map((radioButton) => {
      if (radioButton.id.length > 0 && radioButton.id.includes('-cancel')) {
        return true;
      }
      return false;
    });
    return checkCancelledServices.every(cancelledService => cancelledService);
  };

  render() {
    if (this.props.dataLoaded) {
      const
        {
          mailServiceExit: {
            title: pageTitle,
            summaryTitle: mailServiceExitSummaryTitle,
            summary: mailServiceExitSummary,
            alreadySubmittedSummary,
          },
          actions: {
            actionsTitle: actionsYouCanTakeTitle,
          },
          migrate: {
            currentServices,
            currentServicesSelectAllMobile,
            additionalLicenses: {
              formFields: {
                usersOrLicenses,
              },
            },
            customerDetails: {
              title: customerDetailsTitle,
              formFields,
            },
            yourApplication: {
              summaryTitle: yourApplicationSummaryTitle,
              summary: yourApplicationSummary,
            },
            privacy: {
              summaryTitle: privacySummaryTitle,
              summary: privacySummary,
            },
            additionalLicenses: {
              addMoreText: addMoreLicencesText,
              collapseText,
            },
            additionalInformation,
          },
          confirmChanges: {
            summaryTitle: confirmChangesSummaryTitle, summary: confirmChangesSummary,
            migrateAll: { summary: migrateAllSummary, title: migrateAllTitle },
            contactAe: { summary: contactAeSummary, title: contactAeTitle },
            submitButton,
          },
          cancelChanges: {
            summary: cancelChangesSummary,
            cancelAll: { title: cancelAllTitle },
            cancelOnDeadLine: { title: cancelOnDeadLineTitle },
          },
        } = this.props.authorableContent;
      const {
        emailAddressText: emailAddressHeading,
        title: currentServicesTitle,
        selectAllText,
        formFields: {
          services: {
            errorText: currentServicesErrorText,
            options: additionalServicesOptions,
          },
        },
      } = currentServices;
      const {
        formFields: {
          services: {
            options: selectAllOptions,
          },
        },
      } = currentServicesSelectAllMobile;
      const contentHeader = {
        heading: pageTitle,
        description: '',
      };
      const customerDetailsFormFieldsIds = {
        companyTradingName: CUSTOMER_DETAILS_COMPANY_TRADING_NAME,
        abnAndAcn: CUSTOMER_DETAILS_ABN_ACN,
        streetAddress: CUSTOMER_DETAILS_STREET_ADDRESS,
        suburb: CUSTOMER_DETAILS_SUBURB,
        state: CUSTOMER_DETAILS_STATE,
        postcode: CUSTOMER_DETAILS_POST_CODE,
        firstName: CUSTOMER_DETAILS_FIRST_NAME,
        lastName: CUSTOMER_DETAILS_LAST_NAME,
        billOrAccountNumber: CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER,
        adminEmailAdress: CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS,
        contactPhoneNumber: CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER,
      };
      const confirmChangesRadioButtonsOptions = [{
        radioButtonId: RADIO_BUTTON_CONFIRM_ID,
        radioButtonLabel: migrateAllTitle,
        radioButtonDesc: stripStartingAndEndingPTags(migrateAllSummary),
        radioButtonChecked: this.state.confirmChangesRadioButtons.filter(option => option.id === RADIO_BUTTON_CONFIRM_ID)[0].checked,
        onRadioButtonCallBackActionWithToggle: this.onConfirmChangesRadioButtonsToggle,
      },
      {
        radioButtonId: RADIO_BUTTON_REVIEW_ID,
        radioButtonLabel: contactAeTitle,
        radioButtonDesc: stripStartingAndEndingPTags(contactAeSummary),
        radioButtonChecked: this.state.confirmChangesRadioButtons.filter(option => option.id === RADIO_BUTTON_REVIEW_ID)[0].checked,
        onRadioButtonCallBackActionWithToggle: this.onConfirmChangesRadioButtonsToggle,
      }];
      const cancelServicesRadioButtonsOptions = [{
        radioButtonId: RADIO_BUTTON_CANCEL_ALL_ID,
        radioButtonLabel: cancelAllTitle,
        radioButtonDesc: stripStartingAndEndingPTags(''),
        radioButtonChecked: this.state.cancelServicesRadioButtons.filter(option => option.id === RADIO_BUTTON_CANCEL_ALL_ID)[0].checked,
        onRadioButtonCallBackActionWithToggle: this.onCancelServicesRadioButtonsToggle,
      },
      {
        radioButtonId: RADIO_BUTTON_CANCEL_ON_DEADLINE_ID,
        radioButtonLabel: cancelOnDeadLineTitle,
        radioButtonDesc: stripStartingAndEndingPTags(''),
        radioButtonChecked: this.state.cancelServicesRadioButtons.filter(option => option.id === RADIO_BUTTON_CANCEL_ON_DEADLINE_ID)[0].checked,
        onRadioButtonCallBackActionWithToggle: this.onCancelServicesRadioButtonsToggle,
      }];
      const { customerEmailAddresses, userSubmitted } = this.props;
      const trueValue = true;
      return (
        <EventsAppWrapper>
          <div className="hosted-migration root-container container">
            <ViewHeader content={contentHeader} />
            <SummaryDetails
              summaryTitle={mailServiceExitSummaryTitle}
              summaryText={userSubmitted === false ? stripStartingAndEndingPTags(mailServiceExitSummary)
                : stripStartingAndEndingPTags(alreadySubmittedSummary)}
            />
            { userSubmitted === false &&
            (
              <React.Fragment>
                <div className="section-actions">
                  <SummaryDetails summaryTitle={actionsYouCanTakeTitle} summaryText="" />
                </div>
                {
                  true &&
                    <React.Fragment>
                      <CurrentServices
                        emailAddressHeading={emailAddressHeading}
                        currentServicesTitle={currentServicesTitle}
                        currentServicesOptions={additionalServicesOptions}
                        currentServicesRadioButtonStatus={this.state.currentServicesRadioButtonStatus}
                        currentServicesSelectAllRadioButtonStatus={this.state.currentServicesSelectAllRadioButtonStatus}
                        onRadioButtonCallBackAction={this.onCurrentServicesRadioButtonCallBackAction}
                        onRadioButtonSelectAllCallBackAction={this.onCurrentServicesSelectAllRadioButtonCallBackAction}
                        customerEmailAddresses={customerEmailAddresses}
                        selectAllText={selectAllText}
                        selectAllOptions={selectAllOptions}
                      />
                      {
                        this.state.showCurrentSerivceError ? (
                          <div id="current-services-error-text"><FormError errorText={currentServicesErrorText} /></div>
                        ) : null
                      }
                      { this.state.allServicesCancelled === false &&
                          (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-12 pl-sm-0">
                                  <HMEExpandCollapse
                                    isExpanded={this.state.isAdditionalLicencesOpen}
                                    onClick={this.onCurrentServicesExpandCollapseClick}
                                  />
                                  {
                                    this.state.isAdditionalLicencesOpen ? (
                                      <span className="hme-text">{collapseText}</span>) : (<span className="hme-text">{addMoreLicencesText}</span>)
                                  }
                                </div>
                              </div>
                              {
                                this.state.isAdditionalLicencesOpen &&
                                <AdditionalLicences
                                  additionalLicencesDetails={additionalServicesOptions}
                                  additionalLicencesQuantity={this.state.additionalLicencesQuantity}
                                  usersOrLicencesFormField={usersOrLicenses}
                                  handleOnChange={this.handleOnChangeAdditionLicences}
                                  handleOnBlur={this.handleOnBlurAdditionLicences}
                                />
                              }
                              <SummaryDetails summaryTitle={customerDetailsTitle} summaryText="" />
                              <div id="customer-details" className="customer-details">
                                <CustomerDetails
                                  formFields={formFields}
                                  formFieldsIds={customerDetailsFormFieldsIds}
                                  formFieldsState={this.state.customerDetailsFields}
                                  formFieldsErrors={this.state.customerDetailsFieldsErrors}
                                  handleOnChange={this.handleOnChangeCustomerDetails}
                                  handleOnBlur={this.handleOnBlurCustomerDetails}
                                />
                              </div>
                            </React.Fragment>
                          )
                      }

                      <div className="section-additional-info">
                        <AdditionalInformation
                          authorableContent={additionalInformation}
                          additionalInfoCommentsValue={this.state.additionalInfoComments}
                          handleOnChange={this.handleOnChangeAdditionalInfo}
                          handleOnBlur={this.handleOnBlurAdditionalInfo}
                        />
                      </div>
                      {
                        this.state.allServicesCancelled === false &&
                        (
                          <React.Fragment>
                            <SummaryDetails
                              summaryTitle={yourApplicationSummaryTitle}
                              summaryText={stripStartingAndEndingPTags(yourApplicationSummary)}
                            />
                            <SummaryDetails summaryTitle={privacySummaryTitle} summaryText={stripStartingAndEndingPTags(privacySummary)} />
                          </React.Fragment>
                        )
                      }
                    </React.Fragment>
                }
                {
                  this.state.allServicesCancelled === true &&
                    <React.Fragment>
                      <SummaryDetails summaryTitle="" summaryText={stripStartingAndEndingPTags(cancelChangesSummary)} />
                      <SelectionOption
                        iconType="radioButton"
                        radioButtonOptions={cancelServicesRadioButtonsOptions}
                      />
                    </React.Fragment>
                }
                {
                  this.state.allServicesCancelled === false &&
                  (
                    <div className="confirm-changes-section">
                      <SummaryDetails summaryTitle={confirmChangesSummaryTitle} summaryText={stripStartingAndEndingPTags(confirmChangesSummary)} />
                      <SelectionOption
                        iconType="radioButton"
                        radioButtonOptions={confirmChangesRadioButtonsOptions}
                      />
                    </div>
                  )
                }
              </React.Fragment>
            )
            }

            {userSubmitted === false && (
              <div className="col-12 text-right">
                <Button
                  className="button do-business"
                  buttonText={submitButton}
                  disabled={trueValue}
                  onClick={this.handleSubmit}
                />
              </div>
            )}
            <Recaptcha
              ref={(ref) => { this.recaptcha = ref; }}
              sitekey="6Lc4EygUAAAAAARbXitF8Ce5SDM-mPst4SZV8Tbd"
              onResolved={this.onResolved}
              onError={this.onError}
              onExpired={this.onExpired}
            />

          </div>
        </EventsAppWrapper>
      );
    }
    if (this.props.formSubmitted) {
      const {
        confirmation:
          {
            summary: confirmationSummary,
            summaryTitle: confirmationSummaryTitle,
          },
      } = this.props.authorableContent;

      const confirmationHeader = {
        heading: confirmationSummaryTitle,
        description: renderHTML(stripStartingAndEndingPTags(confirmationSummary)),
      };
      return (
        <EventsAppWrapper>
          <div className="hosted-migration root-container container">
            <ViewHeader content={confirmationHeader} />
          </div>
        </EventsAppWrapper>
      );
    }
    return <Loader />;
  }
}
export default HostedMigrationView;
